import { render, staticRenderFns } from "./NormalSearchNav164.vue?vue&type=template&id=0aa812aa&scoped=true&"
import script from "./NormalSearchNav164.vue?vue&type=script&lang=js&"
export * from "./NormalSearchNav164.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa812aa",
  null
  
)

export default component.exports